<div class="sidenav" [class.open]="opened">
    <div class="text-center position-relative mb-2">
        <h4>Menu</h4>
        <mat-icon class="sidenav-menu-icon" aria-hidden="false" aria-label="double_arrow_icon"
            fontIcon="keyboard_double_arrow_left" (click)="toggleSidenav()"></mat-icon>
    </div>
    <nav>
        <a (click)="navigate('/home')">Home</a>
        <a (click)="navigate('/search')">Ricerca</a>
        <a (click)="navigate('/dashboard')">Cruscotto</a>
        <a (click)="navigate('/documents')">Documenti e Manuali</a>
        <a (click)="navigate('/pills')">
            Pillole formative
            <mat-icon class="chevron-icon" aria-hidden="false" aria-label="chevron-icon" [fontIcon]="showPillsDetail ? 'expand_more' : 'chevron_right'"></mat-icon>
        </a>
        <a *ngIf="showPillsDetail" class="sub-link" (click)="navigate('/athora-pills')">Video Athora</a>
        <a *ngIf="showPillsDetail" class="sub-link" (click)="navigate('/intesa-pills')">Video ISA</a>
    </nav>
</div>